/* BSC Academy — barra d'acquisto fissa · v2 · 26/08/2026
   Compare quando il pulsante vero e uscito dallo schermo verso l'alto.
   Se questo file non gira, la barra resta nascosta e la pagina funziona
   identica: `hidden` e gia nel markup.

   ⚠️ v2 — perche non basta un IntersectionObserver.
   La v1 leggeva `isIntersecting` con `rootMargin: '0px 0px -80% 0px'`.
   Un observer notifica solo i CAMBI di intersezione: con l'ancora sotto lo
   schermo non interseca, con l'ancora sopra nemmeno. Saltando dall'una
   all'altra — un'ancora `#`, un «torna su», un ripristino di posizione —
   lo stato non cambia mai e la callback non viene chiamata: la barra
   restava aperta sopra il pulsante vero, in cima alla pagina.
   Qui si legge la posizione, che e sempre vera, con un giro di
   requestAnimationFrame per non farlo a ogni evento di scorrimento. */
(function () {
  'use strict';
  var barra = document.querySelector('[data-bsc-barra]');
  var ancora = document.getElementById('bsc-compra');
  if (!barra || !ancora) { return; }

  var inCoda = false;

  function aggiorna() {
    inCoda = false;
    /* il pulsante vero e uscito dall'alto quando il suo bordo inferiore
       e sopra il bordo superiore dello schermo */
    barra.hidden = ancora.getBoundingClientRect().bottom > 0;
  }

  function chiedi() {
    if (inCoda) { return; }
    inCoda = true;
    requestAnimationFrame(aggiorna);
  }

  addEventListener('scroll', chiedi, { passive: true });
  addEventListener('resize', chiedi, { passive: true });
  aggiorna();
})();
